import { BaseResource } from "./BaseResource";
import { legacyApiResourceUrl } from "@ploy-lib/core";
class LogEntryExcerptResource extends BaseResource {
    pk() {
        return this.id;
    }
}
LogEntryExcerptResource.urlRoot = legacyApiResourceUrl("Admin/LiveLogger/logs/{context}");
export { LogEntryExcerptResource };
class LogEntryResource extends BaseResource {
    pk() {
        return this.id;
    }
}
LogEntryResource.urlRoot = legacyApiResourceUrl("Admin/LiveLogger/logs/{context}/{id}");
export { LogEntryResource };
export class LoggedMessage {
}
export class LoggedHeader {
}
export class LogStatement {
}
//# sourceMappingURL=LogEntryResource.js.map